<template>
  <div class="mt-1">
    <label class="block">{{title}}</label>
    <InputText 
      v-model="VModel" 
      class="block mb-3" 
      type="number" 
      :placeholder="title" 
      @input="updateInput(inputName, VModel)"
    />
  </div>
</template>

<script>
export default {
  props: {
    numberQuestion: Number,
    questionNumber: Number,
    title: String,
    inputName: String
  },
  name: 'InputTextIdentikit',
  data() { 
    return {
      VModel: "",
    }
  },
  methods: {                     
    updateInput(inputName, VModel){
      this.$emit("updateInput", inputName, VModel);
    },
  }
}
</script>